// extracted by mini-css-extract-plugin
export default {"fixedNotifications":"RWfcM0","fullWidth":"UrBTUm"};